const euroFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

export function formatEuro(value: number): string {
  return euroFormatter.format(value)
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleString('de-DE')
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 100)}%`
}

export function formatKwh(value: number): string {
  return `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(value)} kWh`
}

export type RelativeActivityBucket =
  | { kind: 'today' }
  | { kind: 'yesterday' }
  | { kind: 'daysAgo'; days: number }
  | { kind: 'overAWeek' }
  | { kind: 'unknown' }

/** Datenschutzbewusste grobe Stufung eines Zeitpunkts relativ zu "jetzt" (roofora-task-042: "Kunde
 *  zuletzt aktiv" in "Meine Kontaktanfragen") - Tages-Granularität statt exaktem Zeitstempel, ab
 *  einer Woche nur noch "vor über einer Woche" statt einer wachsenden Tageszahl. Gibt einen reinen
 *  Bucket zurück statt eines fertigen Strings, damit der Aufrufer ihn über i18next übersetzen kann
 *  (de/es/pl) - siehe CraftsmanContactsPage.tsx. */
export function relativeActivityBucket(iso: string | null, now: Date = new Date()): RelativeActivityBucket {
  if (!iso) return { kind: 'unknown' }
  const then = new Date(iso)
  const startOfThen = new Date(then.getFullYear(), then.getMonth(), then.getDate())
  const startOfNow = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const days = Math.round((startOfNow.getTime() - startOfThen.getTime()) / 86_400_000)
  if (days <= 0) return { kind: 'today' }
  if (days === 1) return { kind: 'yesterday' }
  if (days < 7) return { kind: 'daysAgo', days }
  return { kind: 'overAWeek' }
}
